import { AppService } from "app/services/app.service";

import { AppFilter } from "app/models/app-filter.model";
import { TipoCredencial } from "app/models/credencial/tipo-credencial";
import { Observable } from "rxjs";

export abstract class AbCredencial extends AppService {
  abstract prefixo: string;
  abstract salvarAlterarCredencial(entity);
  abstract saveCredenciaisPessoa(dto: any);
  abstract getCredenciais(filter: AppFilter);
  abstract getCredenciaisDTO(): Promise<any>;
  abstract getCredenciaisSemVinculo(): Promise<any>;
  abstract getCredenciaisSemVinculoPorTipo(tipoCredencial: TipoCredencial): Promise<any>;
  abstract getCredenciaisByPessoaId(pessoaId: number): Promise<any>;
  abstract getAllCredenciaisPromise();
  abstract deleteCredencial(id: number);
  abstract getCredencial(id: number);
  abstract sincronizar();
  abstract saveCredenciaisFacial(usuarioCredencialId: number, base64: string): Observable<any>;
  abstract saveCredencialSenha(usuarioCredencialId: number, senha: string): Observable<any>;
}